import { AddHighlightTypes } from './utils.types';

const addHighlightBold = (string: AddHighlightTypes) => {
  return string?.replace(/\[(.*?)\]/g, '<span style="font-weight: 500;">$1</span>') ?? '';
};

export default addHighlightBold;
